"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internalGroupTranslations = {
    nameLabel: "Group Name",
    namePlaceholder: "Group Name",
    nameError: "Please enter group name",
    aboutLabel: "About",
    aboutPlaceholder: "N/A",
    uploadError: "Image upload failed. Please try again.",
    editInternalGroup: "Edit Internal Group",
};
exports.default = internalGroupTranslations;
